import { render, staticRenderFns } from "./Wordmap.vue?vue&type=template&id=3d9f3e80&scoped=true&"
import script from "./Wordmap.vue?vue&type=script&lang=js&"
export * from "./Wordmap.vue?vue&type=script&lang=js&"
import style0 from "./Wordmap.vue?vue&type=style&index=0&id=3d9f3e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f3e80",
  null
  
)

export default component.exports